module.exports = __webpack_public_path__ + "media/images/send-9e27cbcf47b1feb1e0d68e32f7e0f422.svg";